<template>
  <svg :id="id" class="pie-graph" viewBox="0 0 200 200"></svg>
</template>

<script lang="ts">
import Vue, { PropType } from 'vue'
import Component from 'vue-class-component'

import { arc as d3arc, pie as d3pie } from 'd3-shape'
import { select } from 'd3-selection'
import { GraphItem } from '@/components/public/GraphTable/types'

const props = {
  items: {
    type: Array as PropType<GraphItem[]>,
    required: true,
  },
  id: {
    type: String,
    required: true,
  },
}

// eslint-disable-next-line no-use-before-define
@Component<PieGraph>({
  watch: {
    items() {
      this.updateChart()
    },
    graphStyle() {
      this.updateChart()
    },
  },
})
export default class PieGraph extends Vue.extend({ props }) {
  width = 200
  height = 200
  outerRadius = 85

  get graphStyle() {
    return this.$typedStore.activeVisualisation.visualisationStore.app.config.appConfig.graphStyle
  }

  get innerRadius() {
    if (this.graphStyle === 'donut') {
      return this.outerRadius - 25
    } else {
      return 0
    }
  }

  mounted() {
    this.updateChart()
  }

  updateChart() {
    const arc = d3arc<GraphItem>().outerRadius(this.outerRadius).innerRadius(this.innerRadius)

    const pie = d3pie<GraphItem>()
      .sort((d) => d.value)
      .value((d) => d.value)

    // Remove existing chart
    select('#' + this.id)
      .selectAll('g')
      .remove()

    // Add new chart
    const svg = select('#' + this.id)
      .append('g')
      .attr('transform', 'translate(' + this.width / 2 + ',' + this.height / 2 + ')')

    const emit = (highlight: string | null) => this.$emit('highlight', highlight)
    const innerRadius = this.innerRadius
    const outerRadius = this.outerRadius
    const g = svg
      .selectAll('.arc')
      .data(pie(this.items))
      .enter()
      .append('g')
      .append('path')
      // @ts-ignore d3 ts issue
      .attr('d', arc)
      .style('fill', (d) => d.data.color)
      .on('mouseover', function (d3event, d) {
        const nodes = g.nodes()
        const i = nodes.indexOf(this)
        select(nodes[i])
          // @ts-ignore d3 ts issue
          .attr(
            'd',
            // @ts-ignore
            d3arc()
              .innerRadius(innerRadius)
              .outerRadius(outerRadius * 1.1),
          )

        emit(d.data.title)
      })
      .on('mouseout', function () {
        const nodes = g.nodes()
        const i = nodes.indexOf(this)
        select(nodes[i])
          // @ts-ignore d3 ts issue
          .attr('d', d3arc().innerRadius(innerRadius).outerRadius(outerRadius))
        emit(null)
      })
      .raise()
  }
}
</script>

<style lang="scss" scoped>
.pie-graph {
  width: 100%;
  height: auto;
  display: block;
}
</style>
